<script setup lang="ts">
/**
 * Web-only CTA — many web visitors are here to get the app (brief §17).
 * Hidden in native builds.
 */
import { Capacitor } from '@capacitor/core';
import AppLogo from '@/components/AppLogo.vue';
import ComingSoonStores from '@/components/paywall/ComingSoonStores.vue';

const isNative = Capacitor.isNativePlatform();
</script>

<template>
  <div v-if="!isNative" class="get-app-cta">
    <div class="cta-head">
      <AppLogo :size="18" />
      <span>Get the app</span>
    </div>
    <p>Bezier trace, PSD/vector export, and access to every pattern — one purchase, yours forever.</p>
    <ComingSoonStores size="sm" />
  </div>
</template>

<style scoped>
.get-app-cta {
  margin: 8px;
  padding: 12px;
  background: rgba(122, 122, 204, 0.07);
  border: 1px solid var(--ui-border);
  border-radius: 10px;
}

.cta-head {
  display: flex;
  align-items: center;
  gap: 7px;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-primary);
  margin-bottom: 6px;
}

p {
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--text-muted);
}
</style>
